export enum CultureEnum {
	enUS = "en-US",
	esMX = "es-MX",
}
